<div class="mx-auto max-w-[90rem] py-6">
  <h1 class="px-2 pb-4">Network Operations</h1>

  <article
    class="mx-auto w-full rounded-2xl bg-white p-6 shadow-sm transition-[padding] duration-300 ease-in-out"
  >
    <section>
      <h2 [routerLink]="[]" id="what-we-do" [fragment]="'what-we-do'">
        What we do
      </h2>

      <p class="mb-3">
        The Network Operations Center (NOC) strives to put customer satisfaction
        at the forefront of every aspect of our support model. Our NOC would be
        the first point of contact for any issues that may arise with your
        service after the service has been installed. This would include
        addressing any problems negatively impacting your service, change
        management, coordinating maintenance activity and analyzing and
        responding to deviations in our network performance monitoring.
      </p>
      <p class="mb-3">
        Our focus is clear and consistent communication, timely updates, and
        one-time resolution of any problems that may arise. Our technicians are
        available 24x7x365 to assist you in any way we can with the vast
        majority of our calls being answered and attended to in under 20
        seconds.
      </p>
      <p class="mb-3">We look forward to helping you in any way we can!</p>
    </section>

    <section>
      <h2 id="contact-us" class="mb-3 mt-8">
        <span
          class="relative cursor-pointer before:absolute before:left-[-1rem] before:scale-125 before:font-semibold before:not-italic before:text-gray-300 before:opacity-0 before:content-['#'] hover:before:animate-pulse"
          [routerLink]="[]"
          [fragment]="'contact-us'"
        >
          Contact Us
        </span>
      </h2>

      <div
        class="mb-3 w-min max-w-full overflow-x-auto overflow-y-hidden whitespace-nowrap rounded-md border border-gray-300"
      >
        <table class="overflow-hidden rounded-md border">
          <tr>
            <td class="border border-gray-300 px-3 py-2">Phone Number</td>
            <td class="border border-gray-300 px-3 py-2">
              <a href="tel:+18668920915" class="text-blue-600 underline"
                >+1 866 892 0915</a
              >
            </td>
          </tr>
          <tr class="bg-gray-50">
            <td class="border border-gray-300 px-3 py-2">
              Outage/Technical Issues
            </td>
            <td class="border border-gray-300 px-3 py-2">
              <a
                href="mailto:CBNnoc@comcast.com"
                class="text-blue-600 underline"
                >CBNnoc&#64;comcast.com</a
              >
            </td>
          </tr>
          <tr>
            <td class="border border-gray-300 px-3 py-2">Change Management</td>
            <td class="border border-gray-300 px-3 py-2">
              <a
                href="mailto:CBNsupport@comcast.com"
                class="text-blue-600 underline"
                >CBNsupport&#64;comcast.com</a
              >
            </td>
          </tr>
        </table>
      </div>

      <p class="mb-3 font-semibold italic">
        Please dial in for all urgent issues and Escalation requests to ensure a
        timely response.
      </p>

      <h2 id="noc-contacts" class="mb-3 mt-8">
        <span
          class="relative cursor-pointer before:absolute before:left-[-1rem] before:scale-125 before:font-semibold before:not-italic before:text-gray-300 before:opacity-0 before:content-['#'] hover:before:animate-pulse"
          [routerLink]="[]"
          [fragment]="'noc-contacts'"
        >
          NOC Contacts & Escalation Procedures
        </span>
      </h2>

      <div class="mb-3">
        <app-severity-level-contacts-grid
          [severityLevelContacts]="nocSeverityLevelContacts"
        />
      </div>

      <h2 id="msc-contacts" class="mb-3 mt-8">
        <span
          class="before:text-grey-300 relative cursor-pointer before:absolute before:left-[-1rem] before:scale-125 before:font-semibold before:not-italic before:opacity-0 before:content-['#'] hover:before:animate-pulse"
          [routerLink]="[]"
          [fragment]="'msc-contacts'"
        >
          MSC Contacts & Escalation Procedures
        </span>
      </h2>

      <div class="mb-3">
        <app-severity-level-contacts-grid
          [severityLevelContacts]="mscSeverityLevelContacts"
        />
      </div>

      <h2 id="severity-definitions" class="mb-3 mt-8 italic">
        <span
          class="relative cursor-pointer before:absolute before:left-[-1rem] before:scale-125 before:font-semibold before:not-italic before:text-gray-300 before:opacity-0 before:content-['#'] hover:before:animate-pulse"
          [routerLink]="[]"
          [fragment]="'severity-definitions'"
        >
          Severity Definitions
        </span>
      </h2>

      <div class="text-sm">
        <p id="5th-level">
          <span
            class="relative cursor-pointer before:absolute before:left-[-1rem] before:scale-125 before:font-semibold before:not-italic before:text-gray-300 before:opacity-0 before:content-['#'] hover:before:animate-pulse"
            [routerLink]="[]"
            [fragment]="'5th-level'"
          >
            <strong>Severity 5:&nbsp;</strong>
            <span class="opacity-70">(Highest)</span>
          </span>
        </p>
        <ul class="mb-3 ml-4 list-inside list-disc">
          <li>Critical network failure</li>
          <li>Entire network or systems down or inoperative</li>
          <li>Service affecting event &mdash; Severe business impact</li>
          <li>Continuous network performance impairment</li>
          <li>
            <span class="font-semibold">Resolution ETAs:</span>
            <ul class="ml-4 list-inside list-disc">
              <li><b>Tech on Duty:</b> Immediate</li>
              <li><b>Sr. Tech on Duty:</b> 1 hour</li>
              <li><b>Manager:</b> 4 hours</li>
              <li><b>VP Level:</b> 16 hours</li>
            </ul>
          </li>
        </ul>

        <p id="4th-level">
          <span
            class="relative cursor-pointer before:absolute before:left-[-1rem] before:scale-125 before:font-semibold before:not-italic before:text-gray-300 before:opacity-0 before:content-['#'] hover:before:animate-pulse"
            [routerLink]="[]"
            [fragment]="'4th-level'"
          >
            <strong>Severity 4:&nbsp;</strong>
            <span class="opacity-70">(High)</span>
          </span>
        </p>
        <ul class="mb-3 ml-4 list-inside list-disc">
          <li>Significant network degradation</li>
          <li>Service affecting &mdash; business impact</li>
          <li>
            <span class="font-semibold">Resolution ETAs:</span>
            <ul class="ml-4 list-inside list-disc">
              <li><b>Tech on Duty:</b> Immediate</li>
              <li><b>Sr. Tech on Duty:</b> 4 hours</li>
              <li><b>Manager:</b> 8 hours</li>
              <li><b>VP Level:</b> 48 hours</li>
            </ul>
          </li>
        </ul>

        <p id="3rd-level">
          <span
            class="relative cursor-pointer before:absolute before:left-[-1rem] before:scale-125 before:font-semibold before:not-italic before:text-gray-300 before:opacity-0 before:content-['#'] hover:before:animate-pulse"
            [routerLink]="[]"
            [fragment]="'3rd-level'"
          >
            <strong>Severity 3:&nbsp;</strong>
            <span class="opacity-70">(Normal)</span>
          </span>
        </p>
        <ul class="mb-3 ml-4 list-inside list-disc">
          <li>Minor network or system event/impairment</li>
          <li>Service affecting &mdash; minimal business impact</li>
          <li>Low priority</li>
          <li>
            <span class="font-semibold">Resolution ETAs:</span>
            <ul class="ml-4 list-inside list-disc">
              <li><b>Tech on Duty:</b> Immediate</li>
              <li><b>Sr. Tech on Duty:</b> 48 hours</li>
              <li><b>Manager:</b> As Needed</li>
              <li><b>VP Level:</b> As Needed</li>
            </ul>
          </li>
        </ul>

        <p id="2nd-level">
          <span
            class="relative cursor-pointer before:absolute before:left-[-1rem] before:scale-125 before:font-semibold before:not-italic before:text-gray-300 before:opacity-0 before:content-['#'] hover:before:animate-pulse"
            [routerLink]="[]"
            [fragment]="'2nd-level'"
          >
            <strong>Severity 2:&nbsp;</strong>
            <span class="opacity-70">(Low)</span>
          </span>
        </p>
        <ul class="mb-3 ml-4 list-inside list-disc">
          <li>Passive network or system issue/event</li>
          <li>Configuration and Design</li>
          <li>General Question</li>
          <li>Change Control</li>
          <li>
            <span class="font-semibold">Resolution ETAs:</span>
            <ul class="ml-4 list-inside list-disc">
              <li><b>Tech on Duty:</b> Immediate</li>
              <li><b>Sr. Tech on Duty:</b> As Needed</li>
              <li><b>Manager:</b> As Needed</li>
              <li><b>VP Level:</b> As Needed</li>
            </ul>
          </li>
        </ul>
      </div>
    </section>

    <section>
      <h2 id="proactive-monitoring" class="mb-3 mt-8">
        <span
          class="relative cursor-pointer before:absolute before:left-[-1rem] before:scale-125 before:font-semibold before:not-italic before:text-gray-300 before:opacity-0 before:content-['#'] hover:before:animate-pulse"
          [routerLink]="[]"
          [fragment]="'proactive-monitoring'"
        >
          Proactive Monitoring and Notification Standards
        </span>
      </h2>
      <p class="mb-3">
        We proactively monitor Node/Device reachability of our managed CPE
        device every five (5) minutes with a failure being recognized if the
        device misses three (3) consecutive polling intervals. If there is a
        node reachability, a trouble ticket will automatically open and send an
        e-mail alert to the customer's Primary Outage Contact with the trouble
        ticket and a note for the customer to confirm the outage.
      </p>
      <p class="mb-3">
        This ticket will be set in to a “Pending Customer” status until the
        customer confirms the outage is genuine, and there is no local power
        issue or inside wiring work being performed at the customer premise.
        Once the customer confirms there is a genuine service issue, they should
        contact the NOC via phone, while referencing the Proactive Ticket
        number. The Proactive Ticket will then go in to a “Working” status, and
        the NOC will move forward to troubleshoot and isolate the problem. This
        change in status marks the beginning of the time interval for issue
        resolution.
      </p>
      <p class="mb-3">
        If the customer does not notify the NOC of any service affecting
        condition or issue, the trouble ticket will be automatically closed in
        24 hours from the time of the initial notification if the service issues
        resolves. If the site remains unreachable, our ticket will remain open
        pending customer confirmation.
      </p>
      <ul class="mb-3 ml-4 list-inside list-disc">
        <li>
          Our NOC will require a site Local Contact name, phone number and site
          access-hours to open a ticket with our underlying vendors for
          investigation.
        </li>
        <li>
          Power should be verified to all equipment attached to the service.
        </li>
      </ul>
    </section>

    <section>
      <h2 id="change-management" class="mb-3 mt-8">
        <span
          class="relative cursor-pointer before:absolute before:left-[-1rem] before:scale-125 before:font-semibold before:not-italic before:text-gray-300 before:opacity-0 before:content-['#'] hover:before:animate-pulse"
          [routerLink]="[]"
          [fragment]="'change-management'"
        >
          Change Management (Support)
        </span>
      </h2>
      <ul class="mb-3 ml-4 list-inside list-disc">
        <li>
          All non-service affecting change requests should be submitted via
          email to
          <a href="mailto:CBNsupport@comcast.com" class="underline"
            >CBNsupport&#64;comcast.com</a
          >.
        </li>
        <li>
          Non-service affecting change management events are defined as items
          such as CPE Configuration Changes, Firewall Changes, Routing Changes,
          and Utilization Report Requests.
        </li>
        <li>
          These non-service affecting change requests are managed by the Support
          Team during normal business hours of 8:00am to 8:00pm Central, Monday
          – Friday.
        </li>
        <li>
          An acknowledgement of receipt for the change management request will
          be made within 2 hours.
        </li>
        <li>
          Most change management request are completed within 24 &ndash; 72
          hours, with Expedites being completed same day.
        </li>
        <li>
          If additional time is needed to process your request, Support
          <a href="mailto:CBNsupport@comcast.com" class="underline"
            >CBNsupport&#64;comcast.com</a
          >
          will provide more details regarding any delays.
        </li>
        <li>
          Change Requests requested outside of the normal business hours of
          8:00am to 8:00pm Central, Monday &ndash; Friday will be subject to
          additional professional services fees.
        </li>
      </ul>
    </section>
  </article>
</div>
